
<template>
  <div class="home">
    <div class="hero is-fullheight">
      <div class="hero-body">
        <h1 class="title">the body we all want</h1>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//axios for API Consumption
import axios from 'axios';

export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      info: {}
    }
  },
  mounted () {
    axios
    .get('https://api.coindesk.com/v1/bpi/currentprice.json')
    .then(function(response){
      //handle success
      console.log(response.data.bpi);
      //console.log(this.info);
      const bpi = response.data.bpi;
      this.info = bpi;
      //console.log(this.info);
      console.log(bpi);
    })
    .catch(function(error){
      //handle error
      console.log(error);
    })
  }
}
</script>

<style scoped>
*{
   overflow: hidden;
}
.home{
  margin:0;
  padding:0;
  box-sizing:border-box;
}
.hero{
  background-image:url(../assets/body4.jpg);
  background-size:cover;
  background-position:50%;
}
.title{
  font-size:3rem;
  font-family:monospace;
  margin:200px auto;
  position: relative;
  color:orangered;
  text-transform: uppercase;
  text-align: center;
  display:flex;
  align-items: center;
  justify-content: center;
}
</style>